<app-spinner-overlay></app-spinner-overlay>

<!-- SONO IN CREAZIONE DOMANDE -->
@if (data.dialogCreaNuovo) {
  <h2 mat-dialog-title>Configurazione Domanda Informativa Aziendale</h2>

  <div style="height: 15px"></div>

  <ng-scrollbar>
    <div style="padding-right: 20px !important">
      <ng-container [ngTemplateOutlet]="domanda"></ng-container>
    </div>
  </ng-scrollbar>

  <footer mat-dialog-actions class="dialog-footer-cont">
    <div>
      <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
    </div>
    <div>
      <button mat-flat-button color="primary" (click)="salvaInHtml()" class="primary-button">
        Salva
      </button>
    </div>
    <div>
      <button mat-flat-button (click)="ctrOpenPromptAI()" class="ai-button">
        <mat-icon>auto_awesome</mat-icon>Prompt AI
      </button>
    </div>
  </footer>
} @else {
  <!-- SONO IN CREAZIONE INFORMATIVA AZIENDALE -->
  <ng-container [ngTemplateOutlet]="domanda"></ng-container>
}

<!-------------------- TEMPLATE ----------------- -->
<ng-template #domanda>
  <div appFormContainer [larghezza]="4" [formGroup]="formDomanda" [alignItems]="'flex-start'">
    <!-- LINEA GUIDA DOMANDA -->

    @for (lineaGuida of lineeGuidaForm; track $index) {
      <mat-form-field
        (mousedown)="$event.stopPropagation()"
        appFormElement
        [larghezza]="4"
        [riempi]="true"
      >
        <mat-label>Linea Guida</mat-label>
        <textarea
          #inputLineaGuida
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          placeholder="Linea Guida"
          [formControl]="lineaGuida"
          [rows]="data.dialogCreaNuovo ? 4 : 1"
        ></textarea>
        <mat-error appFormError></mat-error>
      </mat-form-field>
    }
    <div appFormElement [larghezza]="4" [riempi]="true" class="cnt-dom-tip">
      <mat-form-field
        (mousedown)="$event.stopPropagation()"
        appFormElement
        [larghezza]="3"
        [riempi]="true"
      >
        <mat-label>Domanda</mat-label>
        <textarea
          #inputDesc
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          placeholder="Domanda"
          formControlName="domanda"
          [rows]="data.dialogCreaNuovo ? 4 : 1"
          (input)="sincronizzaDomanda()"
        ></textarea>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <div style="display: flex; column-gap: 10px">
        <mat-form-field
          style="display: flex"
          (mousedown)="$event.stopPropagation()"
          appFormElement
          [larghezza]="1"
          [riempi]="true"
        >
          <mat-label>Tipologia Risposta</mat-label>
          <mat-select formControlName="tipo" (valueChange)="cambiaTipologia($event, formDomanda)">
            @for (tpRisp of informativaAziendale.arrayTipologiaRisposta; track $index) {
              <mat-option [value]="tpRisp.chiave">{{ tpRisp.valore }}</mat-option>
            }
          </mat-select>
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <div appFormElement [larghezza]="0.5">
          <section>
            <mat-checkbox
              (change)="updateAllChild($event.checked, formDomanda)"
              (click)="$event.stopPropagation()"
              formControlName="moduloCompleto"
              >Modulo Completo</mat-checkbox
            >
          </section>
        </div>
      </div>
    </div>

    @if (
      formDomanda.get('tipo')?.value === 'numero_intero' ||
      formDomanda.get('tipo')?.value === 'numero_decimale'
    ) {
      <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
        <mat-label>Categorie</mat-label>
        <mat-select [placeholder]="'Categorie'" formControlName="idCategoriaUnitaDiMisura">
          @for (cat of arrayCategorie; track $index) {
            <mat-option [value]="cat.id">{{ cat.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (formDomanda.get('idCategoriaUnitaDiMisura')?.value) {
      <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
        <mat-label>Unità Di Misura</mat-label>
        <mat-select [placeholder]="'Unità Di Misura'" formControlName="idUnitaDiRiferimento">
          @for (um of mapCateg; track $index) {
            <mat-option [value]="um.id">{{ um.descrizione }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (
      formDomanda.get('tipo')?.value === 'scelta_singola' ||
      formDomanda.get('tipo')?.value === 'scelta_multipla'
    ) {
      <div appFormElement [larghezza]="3" [riempi]="true">
        <app-separatore-label
          titoloSeparatore="Risposte"
          [styleSeparatore]="'small'"
        ></app-separatore-label>
      </div>

      <div style="height: 25px"></div>

      <!-- Risposte -->
      <mat-accordion appFormElement [larghezza]="4">
        <div cdkDropList (cdkDropListDropped)="dropOpzioni($event, opzioniFormArray)">
          @for (opzioni of opzioniControls; track $index; let idx2 = $index) {
            <mat-expansion-panel expanded="false" cdkDrag>
              <mat-expansion-panel-header>
                <mat-panel-title style="font-size: 12px">
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  {{ opzioni.get('valore')?.value }}
                </mat-panel-title>
                <mat-panel-description>
                  <button
                    mat-icon-button
                    title="Elimina Sottorisposta"
                    aria-label="Elimina Sottorisposta"
                    color="warn"
                    (click)="elimina(opzioniFormArray, idx2)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                  <!-- CHECK MODULO COMPLETO -->
                  <form [formGroup]="opzioni">
                    <section>
                      <mat-checkbox
                        color="primary"
                        (click)="$event.stopPropagation()"
                        formControlName="moduloCompleto"
                        (change)="checkPadreDopoCambioFiglio(formDomanda)"
                        >Modulo Completo</mat-checkbox
                      >
                    </section>
                  </form>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div appFormContainer [larghezza]="3" [formGroup]="opzioni">
                <mat-form-field
                  (mousedown)="$event.stopPropagation()"
                  appFormElement
                  [larghezza]="3"
                  [riempi]="true"
                >
                  <mat-label>Descrizione</mat-label>
                  <textarea
                    #inputDesc
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    placeholder="Descrizione"
                    formControlName="valore"
                    rows="1"
                  ></textarea>
                  <mat-error appFormError></mat-error>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          }
        </div>
      </mat-accordion>

      <div appFormElement [larghezza]="3" [riempi]="true" style="margin-top: 10px">
        <button
          mat-stroked-button
          (click)="addOpzioni($any(formDomanda.get('opzioni')))"
          style="height: 56px; width: 100%; font-weight: bold"
        >
          Aggiungi Risposte
        </button>
      </div>
    }
  </div>
</ng-template>
